<template>
    <div
        class="modal fade text-left"
        :id="modalId"
        tabindex="-1"
        role="dialog"
        aria-labelledby="basicModalLabel3"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
    >
        <div
            class="modal-dialog modal-dialog-centered"
            :class="
                isNameNumber
                    ? 'name-number-modal'
                    : 'manage_add_shap_custom cart_modal_s-img'
            "
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="onClose && onClose()"
                    >
                        <img src="/maincss/images/cancel.svg" alt=" " />
                    </button>
                </div>
                <div class="modal-body modal-scroll artwork-preview-modal-body">
                    <template v-if="designImages && designImages.length && flatCanvasImages.length">
                        <div v-if="isNameNumber && firstCanvasImage" class="nn-wrapper">
                            <img :src="canvasImageDisplaySrc(firstCanvasImage)" class="nn-image" />
                        </div>

                        <div v-else>
                            <div
                                v-for="(design_image, dIdx) in designImages"
                                :key="dIdx"
                            >
                                <div class="row main_title">
                                    <h5
                                        class="cart_popup_title"
                                        v-if="
                                            design_image.canvas_images &&
                                                design_image.canvas_images.length > 0
                                        "
                                    >
                                        {{
                                            (design_image.label || "").replace(
                                                /(?:^|\s|-)\S/g,
                                                (x) => x.toUpperCase()
                                            )
                                        }}
                                    </h5>
                                </div>
                                <div class="row image-align-col">
                                    <div
                                        class="col product_details-cart"
                                        v-for="(canvas_image, cIdx) in (design_image.canvas_images || [])"
                                        :key="cIdx"
                                    >
                                        <div class="choice_img">
                                            <img :src="canvasImageDisplaySrc(canvas_image)" />
                                            <label
                                                class="order_shape_title"
                                                v-tooltip="canvas_image.image_name"
                                            >
                                                {{ canvas_image.image_name }}
                                            </label>
                                            <label class="dimension_text">
                                                Artwork Size {{ canvas_image.width_inch }}
                                                <span>&#8243;</span>
                                                <b>&#215;</b>
                                                {{ canvas_image.height_inch }}
                                                <span>&#8243;</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else class="artwork-preview-empty text-muted py-4 text-center">
                        No artwork available for this item.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ArtworkPreviewModal",
    props: {
        modalId: {
            type: String,
            required: true
        },
        designImages: {
            type: Array,
            required: false,
            default: () => []
        },
        onClose: {
            type: Function,
            required: false
        }
    },
    methods: {
        canvasImageDisplaySrc(ci) {
            if (!ci) return "";
            const filled =
                ci.filled_artwork_url != null &&
                String(ci.filled_artwork_url).trim() !== "";
            if (filled) return String(ci.filled_artwork_url).trim();
            return ci.image_path || "";
        }
    },
    computed: {
        flatCanvasImages() {
            const out = [];
            (this.designImages || []).forEach((di) => {
                (di && di.canvas_images ? di.canvas_images : []).forEach((ci) => {
                    if (
                        ci &&
                        (ci.image_path ||
                            (ci.filled_artwork_url &&
                                String(ci.filled_artwork_url).trim() !== ""))
                    ) {
                        out.push(ci);
                    }
                });
            });
            return out;
        },
        firstCanvasImage() {
            return this.flatCanvasImages.length ? this.flatCanvasImages[0] : null;
        },
        isNameNumber() {
            if (!this.flatCanvasImages.length) return false;
            return this.flatCanvasImages.every(
                (ci) =>
                    (ci.width_inch == null || ci.width_inch === 0) &&
                    (ci.height_inch == null || ci.height_inch === 0)
            );
        }
    }
};
</script>

<style scoped>
.name-number-modal {
    max-width: 420px;
}

.name-number-modal .modal-content {
    border-radius: 6px;
}

/* Prevent modal from collapsing to a thin bar (e.g. when opened from Items by Address) */


.modal-content {
    min-height: 140px;
}

.artwork-preview-modal-body {
    min-height: 80px;
}

.artwork-preview-empty {
    font-size: 14px;
}

.nn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px 32px;
}

.nn-image {
    max-width: 100%;
    height: auto;
    display: block;
}

.modal-header {
    border-bottom: none !important;
}
</style>

